import React from "react";
import { Form, Input, Divider } from "antd";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";

const { TextArea } = Input;

const WrittenFeedback = ({ form }) => {
  return (
    <Form
      className="form"
      layout="vertical"
      form={form}
    >
      <div className="w-full">
        <FormItem
          className="font-medium mb-2"
          name="strengths"
          label="Key Strengths"
          rules={[requiredField]}
        >
          <TextArea
            id="strengths"
            className="input-field"
            maxLength={255}
            placeholder="Highlight the employee's key strengths and positive contributions during this review period..."
          />
        </FormItem>

        <p className="text-[11px] text-muted-foreground -mt-2 mb-4">
          Focus on specific examples and achievements that demonstrate their strengths.
        </p>
      </div>

      <Divider className="my-4" />

      <div className="w-full">
        <FormItem
          className="font-medium mb-2"
          name="improvements"
          label="Areas for Development "
          rules={[requiredField]}
        >
          <TextArea
            id="improvements"
            className="input-field"
            maxLength={255}
            placeholder="Identify areas where the employee can develop and grow their skills..."
          />
        </FormItem>

        <p className="text-[11px] text-muted-foreground -mt-2 mb-4">
          Be constructive and specific about opportunities for growth and development.
        </p>
      </div>

      <Divider className="my-4" />

      <div className="w-full">
        <FormItem
          className="font-medium mb-2"
          name="goals"
          label="Goals for Next Period"
          rules={[requiredField]}
        >
          <TextArea
            id="goals"
            className="input-field"
            maxLength={255}
            placeholder="Set specific, measurable goals for the next review period..."
          />
        </FormItem>

        <p className="text-[11px] text-muted-foreground -mt-2 mb-4">
          Set SMART goals (Specific, Measurable, Achievable, Relevant, Time-bound).
        </p>
      </div>

      <Divider className="my-4" />

      <div className="w-full">
        <FormItem
          className="font-medium mb-2"
          name="comments"
          label="Additional Comments"
        >
          <TextArea
            id="comments"
            className="input-field"
            maxLength={255}
            placeholder="Any additional comments, notes, or context for this review..."
          />
        </FormItem>
      </div>
    </Form>
  );
};
export default WrittenFeedback;